export default () => {
	const sidemenu = document.querySelector('.js-sidemenu')

	document.addEventListener('click', (e) => {
		if (!e.target.closest('.js-sidemenu') && !e.target.closest('.js-sidemenu-button') && !e.target.closest('.js-open-cart')) {
			closeSidemenu()
		}

		if (e.target.closest('.js-sidemenu-button')) {
			let btn = e.target.closest('.js-sidemenu-button')

			clearButtons()
			openSidemenu()
			openTab(btn)
		}

		if (e.target.closest('.js-sidemenu-close')) {
			let btn = e.target.closest('.js-sidemenu-close')
			closeSidemenu()
		}

		if (e.target.closest('.js-mini-bag-empty-link')) {
			let btn = e.target.closest('.js-mini-bag-empty-link')
			closeSidemenu()
		}
	})

	function clearButtons () {
		const buttons = document.querySelectorAll('.js-sidemenu-button')

		buttons.forEach(btn => {
			btn.classList.remove('sidemenu-buttons__button--active')
		})
	}

	function openSidemenu () {
		sidemenu.classList.add('sidemenu--opened')
		document.body.classList.add('is-sidemenu-opened')

		const cartAdd = document.querySelector('.cart-add')
		if (cartAdd) {
			cartAdd.classList.remove('cart-add--visible')
		}
	}

	function closeSidemenu () {
		sidemenu.classList.remove('sidemenu--opened')
		// sidemenu.classList.remove('sidemenu__mini-bag');
		document.body.classList.remove('is-sidemenu-opened')
	}

	function openTab (btn) {
		document.dispatchEvent(new CustomEvent('close-search'));
		const btnData = btn.dataset.target

		const activeBtn = document.querySelector(`.sidemenu-buttons__button[data-target="${btnData}"]`)
		if (activeBtn) {
			activeBtn.classList.add('sidemenu-buttons__button--active')
		}

		const tabs = document.querySelectorAll('.js-sidemenu-tab')

		tabs.forEach(tab => {
			tab.classList.remove('sidemenu__tab--active')
		})

		const activeTab = document.querySelector(`.js-sidemenu-tab[data-tab="${btnData}"]`)
		activeTab.classList.add('sidemenu__tab--active')
	}
}
